import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/storage")({
  component: () => (
    <>
      <div className="page-header">
        <div className="page-title">Storage</div>
        <div className="page-subtitle">Monitor storage usage across organisations</div>
      </div>
    </>
  ),
});
